import { ProjectDtoRelV2 } from '../../../commonTypes/project.types';
import { formatToMonthDayYear } from '../../../util/date/dateFormater';

interface ProjectCardProps {
    project: ProjectDtoRelV2;
    statusColor: string;
    onDragStart: (e: React.DragEvent<HTMLDivElement>, projectId: string) => void;
    onViewDetails: (projectId: string) => void;
}

export const ProjectCard = ({ project, statusColor, onDragStart, onViewDetails }: ProjectCardProps) => {
    const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
        onDragStart(e, project.id);
    };

    return (
        <div
            className="project-card"
            draggable
            onDragStart={handleDragStart}
            onClick={() => onViewDetails(project.id)}
            style={{ backgroundColor: `${statusColor}0F` }}
        >
            <div className="project-card__header">
                <h4 className="project-card__title" style={{ borderColor: `${statusColor}` }}>
                    {project.name}
                </h4>
            </div>
            <div className="project-card__content">
                <p className="project-card__date">{project.clientName || '-'}</p>
                <p className="project-card__date">{project.startDate ? formatToMonthDayYear(project.startDate) : '-'}</p>
            </div>
        </div>
    );
};
